module.exports = [{
      plugin: require('D:/Home/Alymbic/barebones/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/Home/Alymbic/barebones/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
